import { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import config from 'cityads-v3/config'

import {
  selectPage,
  selectPerPage,
  setPage,
  setPerPage
} from 'cityads-v3/reducers/paginator'

export type PaginatorType = [
  number,
  number,
  (evt: unknown, page: number) => void,
  (pageSize: number) => void,
]

export function usePaginator(name: string): PaginatorType {
  const dispatch = useDispatch();
  const page = useSelector(selectPage(name)) ?? 1;
  const perPage = useSelector(selectPerPage(name, config.PAGE_DEFAULT_LIMIT));

  const onChangePage = useCallback((evt: unknown, page: number) => {
    dispatch(setPage({ name, page }));
  }, [dispatch, name])

  const onChangeRowsPerPage = useCallback((perPage: number) => {
    dispatch(setPerPage({ name, perPage }));
  }, [dispatch, name]);

  return [
    page, perPage,
    onChangePage, onChangeRowsPerPage
  ];
}
